export const AppConst = {
  CHAVE_TOKENS: 'ERPTOKEN',
  KEY_CONFIG: 'ERPAPPCONFIG',
  KEY_CONTEXT: 'ERPAPPCONTEXT',
  KEY_ERP_TOKEN: 'ERPTOKEN',
  API_BASEURL: 'api_baseUrl',

  // API's
  KEY_ACCESS_TOKEN: 'token_acesso_usuario',
  KEY_REFRESH_TOKEN: 'refresh_token',
  KEY_TOKEN_EXPIRES_AT: 'expires_at',
  KEY_EXPIRE_IN: 'expires_in',
  KEY_NOME_USUARIO: 'nome_usuario',
  KEY_BREADCRUMBS: 'breadcrumbs',
  KEY_DATALOGIN: 'data_login',
  KEY_FILTROS: 'filtros',
  KEY_FILTROS_DETALHADOS: 'filtros_detalhados',
  KEY_FILTROS_CONTA_CAIXA: 'filtros_conta_caixa',
  KEY_FILTROS_LANCAMENTO: 'filtros_lancamento',
  URL_LOGIN: '/api/connect/token',
  KEY_TOUR_DOWNLOAD: 'tour_download',
  URL_FILTROAVANCADO: '/api/framework/v2/filters',
  URL_FILTRO_AVANCADO_CONTACAIXA_SCHEMA: '/api/financial/v2/cashaccounts/schema',
  URL_FILTRO_AVANCADO_LANCAMENTO_SCHEMA: '/api/financial/v2/entry/schema',
  URL_FILIAIS: '/api/framework/v1/branches/lookup',
  URL_COLIGADAS: '/api/framework/v2/companies/lookup',
  URL_ALIAS: '/api/backoffice/v1/server/alias',
  URL_INDICADORES: '/api/financial/v1/indicators',
  URL_SALDO_CONTAS: '/api/financial/v1/balance',
  URL_SIMULACOES: '/api/financial/v1/cashmanagementsimulation',
  URL_FILTROS: '/api/financial/v1/filter',
  URL_EFETIVACAO_MOVIMENTACAO: '/api/financial/v1/cashmanagement/simulation/effect',
  URL_ESTORNA_MOVIMENTACAO: '/api/financial/v1/cashmanagement/simulation/canceleffect'
}
